// import INavigationItemProps from '../../interfaces/navigationItemProps'
var SidebarMenuItem = /** @class */ (function () {
    function SidebarMenuItem(sidebarMenuItem) {
        if (sidebarMenuItem === undefined) {
            sidebarMenuItem = {
                'exact': false,
                'icon': '',
                'id': '',
                'link': '',
                'name': ''
            };
        }
        this.exact = sidebarMenuItem.exact;
        this.icon = sidebarMenuItem.icon;
        this.id = sidebarMenuItem.id;
        this.link = sidebarMenuItem.link;
        this.name = sidebarMenuItem.name;
    }
    return SidebarMenuItem;
}());
export default SidebarMenuItem;



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/sidebarMenuItem.ts
// module id = 236
// module chunks = 0